import { Box } from "@mui/material";
import React from "react";
import SideMenu from "./side-menu";
import { IWithClassName } from "../../theme/default.theme";
import MainHeader from "./main-header";
import GridViewOutlinedIcon from "@mui/icons-material/GridViewOutlined";
import DesignServicesOutlinedIcon from "@mui/icons-material/DesignServicesOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import PhoneAndroidOutlinedIcon from "@mui/icons-material/PhoneAndroidOutlined";
import PeopleOutlineOutlinedIcon from "@mui/icons-material/PeopleOutlineOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import HelpOutlinedIcon from "@mui/icons-material/HelpOutlined";

const settingsItems = [
  {
    name: "Setting",
    path: "",
    Icon: SettingsOutlinedIcon,
  },
  {
    name: "Help center",
    path: "/help-center",
    Icon: HelpOutlinedIcon,
  },
];

const menuItems = [
  {
    name: "Dashboard",
    path: "/dashboard",
    Icon: GridViewOutlinedIcon,
  },
  {
    name: "Create Campaign",
    path: "/create-campaign",
    Icon: DesignServicesOutlinedIcon,
  },
  {
    name: "Reporting",
    path: "/reporting",
    Icon: BarChartOutlinedIcon,
  },
  {
    name: "Add App",
    path: "/add-app",
    Icon: PhoneAndroidOutlinedIcon,
  },
  {
    name: "Business Users",
    path: "/business-users",
    Icon: PeopleOutlineOutlinedIcon,
    adminOnly: true,
  },
];

interface IProps extends IWithClassName {
  children: React.ReactNode;
  title: string;
}

const DashboardFrame = ({ children, className, title }: IProps) => (
  <Box className={className}>
    <SideMenu menuItems={menuItems} settingsItems={settingsItems} />
    <Box component="main">
      <MainHeader title={title} />
      <Box className="template-container">{children}</Box>
    </Box>
  </Box>
);

export default DashboardFrame;
